import React from 'react';
import PropTypes from 'prop-types';

function Cursor({ color, className, style }) {
  return (
    <svg className={className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.0432796 1.68335C-0.215929 0.671335 0.732064 -0.236737 1.74265 0.0555404L17.0202 4.47406C18.2287 4.82356 18.3516 6.47352 17.2081 6.99547L10.4741 10.0692C10.1941 10.197 9.9661 10.4154 9.82754 10.6885L6.49571 17.2568C5.92992 18.3722 4.27183 18.1927 3.96187 16.9825L0.0432796 1.68335Z" fill={color}/>
    </svg>
  )
}

Cursor.propTypes = {
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default Cursor;
